import gql from 'graphql-tag'
import api from './apiClient'

export default {
  enviarDocumentos: docs =>
    api
      .send({
        query: gql`
          mutation enviarDocumentos($docs: [DocArray!]!) {
            Documento {
              enviarDocumentos(docs: $docs) {
                id
                state
              }
            }
          }
        `,
        variables: {
          docs
        }
      })
      .then(result => result.data.data.Documento.enviarDocumentos),
  downloadPDF: doc =>
    api
      .send({
        query: gql`
          mutation downloadPDF($doc: DocArray!) {
            Documento {
              downloadPDF(doc: $doc) {
                state
                file
              }
            }
          }
        `,
        variables: {
          doc
        }
      })
      .then(result => result.data.data.Documento.downloadPDF),
  reenviarDocumentoOtroCorreo: (doc, emails) =>
    api
      .send({
        query: gql`
          mutation reenviarDocumentoOtroCorreo($doc: DocArray!, $emails: [String!]!) {
            Documento {
              reenviarDocumentoOtroCorreo(doc: $doc, emails: $emails) {
                id
                state
              }
            }
          }
        `,
        variables: {
          doc,
          emails
        }
      })
      .then(result => result.data.data.Documento.reenviarDocumentoOtroCorreo)
}
